import { useCallback, useState } from "react";
import { BzInputText } from "../components";


const GridHeaderSearch = (props) => {
  const { onChangeGridHeaderSearch, gridRef, component, id } = props;

  props.column.addEventListener('filterChanged');
  const [sortValue, setForceUpdate] = useState(null);  //Azeem K: created a dummy state for forcefully re-render
  const onSortChange = useCallback(() => {
    let colId = props?.column?.colId;
    gridRef?.current?.api?.applyColumnState({
      state: [{ colId: colId, sort: sortValue === null ? 'asc' : sortValue === 'asc' ? 'desc' : null }],
      defaultState: { sort: null }
    });
    gridRef?.current?.api?.onSortChanged();
    setForceUpdate(prevStae => prevStae === null ? 'asc' : sortValue === 'asc' ? 'desc' : null);
  }, [sortValue, props, gridRef]);

  //search icon need to set with new styling
  return (
    <div className='d-flex flex-row justify-content-start align-items-center'>
      <div className='position-relative'>
        <div className='icon-14 icon-search icon-grey search-icon-position'></div>
        <BzInputText data-testid='grid-header-search-input' size="sm" id={id} onInput={(e) => onChangeGridHeaderSearch(e)} className='p-l-30 scripname-searchtext text-truncate' type='search' placeholder={component === 'watchlist' ? 'Search in Watchlist' : 'Search scrips'} autoComplete='off' />
      </div>
      <div onClick={(e) => onSortChange(e)} className='ms-2'>
        {props?.column?.getSort() === 'asc' ? <div className='icon-14 icon-sort-up icon-grey' /> : props?.column?.getSort() === 'desc' ? <div className='icon-14 icon-sort-down icon-grey' /> : <div className='icon-14 icon-sort icon-grey' />}
      </div>
    </div>);
};


export default GridHeaderSearch;